<template>
  <div class="panel-container">
    <MysticCommunity
      :pulse="pulse"
      :circleFeed="circleFeed"
      :activeQuest="activeQuest"
      :communityVibes="communityVibes"
      :mysticAidaImageUrl="mysticAidaImageUrl"
      :communityMessages="communityMessages"
      :initialView="initialView"
      :tab="tab"
      @select-reader="$emit('select-reader', $event)"
      @request-auth="$emit('request-auth')"
      @drop-detail-changed="$emit('drop-detail-changed', $event)"
      @meet-reader="$emit('meet-reader', $event)"
      @open-reader-detail="$emit('open-reader-detail', $event)"
      @start-reading="$emit('start-reading', $event)"
      @open-lesson="$emit('open-lesson', $event)"
      @ask-cards="(words, reader, via) => $emit('ask-cards', words, reader, via)"
      @show-pulse="$emit('show-pulse')"
      @view-change="$emit('view-change', $event)"
      @view-deck-gallery="$emit('view-deck-gallery', $event)"
      @ask-mystic="$emit('ask-mystic', $event)"
      @home-changed="$emit('home-changed', $event)"
    />
  </div>
</template>

<script setup>
import MysticCommunity from '@/pages/MysticCommunity.vue'

defineProps({
  pulse: { type: Object, default: null },
  circleFeed: { type: Array, default: () => [] },
  activeQuest: { type: Object, default: null },
  communityVibes: { type: Object, default: null },
  mysticAidaImageUrl: { type: String, default: null },
  communityMessages: { type: Array, default: () => [] },
  initialView: { type: String, default: null },
  tab: { type: String, default: 'seekers' },
})

defineEmits(['close', 'select-reader', 'request-auth', 'drop-detail-changed', 'meet-reader', 'open-reader-detail', 'start-reading', 'open-lesson', 'ask-cards', 'show-pulse', 'view-change', 'view-deck-gallery', 'ask-mystic', 'home-changed'])
</script>

<style scoped>
.panel-container {
  width: 100%;
  min-height: 100%;
  background: #0d0520;
  box-sizing: border-box;
}
</style>
